import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { KeyingAppEnvironmentConfig } from '../configuration/keying.app.environment.config'

@Injectable({
  providedIn: 'root',
})
export class KeyingReportsService {
  constructor(
    @Inject(HttpClient) private httpClient: HttpClient,
    private keyingAppEnvironmentConfig: KeyingAppEnvironmentConfig
  ) {}

  getHistoryTakeOffReport(structureId, keySystemId, orderId, isRequeue) {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/structures/${structureId}/systems/${keySystemId}/orderHistory/${orderId}/${isRequeue}`
    const headers = new HttpHeaders().set('Accept', 'application/allegion.keying.orderHistory.inbound.report+pdf')
    return this.httpClient.get(url, { headers, responseType: 'blob' })
  }

  getOrders(KeySystemId) {
    const url = `${this.keyingAppEnvironmentConfig.getBaseUrl()}/orders/${KeySystemId}`

    return this.httpClient.get<any>(url)
  }
}
